// ユーザーに関するStateの管理
import type { UserInfo, UserState } from "~/types/entity/user";

const stateName = "user";

type UserModelKey = unknown

export const useUserState = (): {
  get: () => Ref<UserState>
  getPersisted: (key: UserModelKey) => Promise<Ref<UserState>>
  set: (v: UserState) => Promise<void>
  setUserInfo: (v: UserInfo) => Promise<void>
} => {
  /**
   * userInfo: ユーザー情報
   * token: Apiアクセスための情報
   */
  const state = useState<UserState>(stateName, (): UserState => ({
    // アクセスを試みていない未定義状態の userInfo
    userInfo: {
      sub: "",
      nickname: "Initializing",
      email: "",
      email_verified: false,
      updated_at: 0,
      circlems_r18: 0,
      can_show_circle_menu: false,
      birthdate: undefined,
      roles: [],
    },
    token: undefined,
  }));

  return {
    get: () => state,
    getPersisted: async (_key: UserModelKey) => {
      return state;
    },
    set: async (v: UserState) => {
      state.value = v;
    },
    setUserInfo: async (v: UserInfo) => {
      state.value = {
        ...state.value,
        userInfo: v
      };
    },
  };
};
